<template>
    <vtk-sidebar-item title="Variáveis" :item-class="itemClass">
        <swx-dropdown
            v-model="colorBy"
            block
            variant="outline-primary"
            :options="colorByOptions"
            :disabled="busy"
        >
            <template #value="{ value, text }"
                ><i
                    :class="{
                        fas: true,
                        'fa-fw': true,
                        'fa-border-all': value.includes('CELLS'),
                        'fa-dot-circle': value.includes('POINTS')
                    }"
                />{{ text }}</template
            >
            <template #option="{ option }"
                ><i
                    :class="{
                        fas: true,
                        'fa-fw': true,
                        'fa-border-all': option.value.includes('CELLS'),
                        'fa-dot-circle': option.value.includes('POINTS')
                    }"
                />{{ option.text }}</template
            >
        </swx-dropdown>
        <swx-dropdown
            v-if="componentInfoOptions.length > 0"
            v-model="componentInfo"
            class="chosen-component-select"
            block
            variant="outline-primary"
            :options="componentInfoOptions"
            :disabled="busy"
        />
    </vtk-sidebar-item>
</template>

<script>
import VtkSidebarItem from "./VtkSidebarItem";
import SwxDropdown from "@/components/SwxDropdown";

const SEP = "-:-";
const TranslationMap = {
    "CN-Results.vtk": {
        MatId: "MatId",
        AvStressX: "Tensão X (MPa)",
        AvStressY: "Tensão Y (MPa)",
        AvStressZ: "Tensão Z (MPa)",
        AvPrincipalStress1: "Tensão principal I (MPa)",
        AvPrincipalStress2: "Tensão principal II (MPa)",
        AvPrincipalStress3: "Tensão principal III (MPa)",
        E_Young: "Módulo de elasticidade (MPa)",
        AvAccumulatedPlasticStrain: "Deformação plástica",
        Displacement: "Deslocamento (m)"
    },
    "Vertedouro-Results.vtk": {
        Displacement: "Deslocamento (m)",
        StressX: "Tensão X (Pa)",
        StressY: "Tensão Y (Pa)",
        StressZ: "Tensão Z (Pa)",
        PrincipalStress: "Tensão Principal",
        MatId: "MatId"
    },
    "BP-Results.vtk": {
        MatId: "MatId",
        StressX: "Tensão X (Pa)",
        StressY: "Tensão Y (Pa)",
        StressZ: "Tensão Z (Pa)",
        PrincipalStress: "Tensão Principal",
        E_Young: "Módulo de elasticidade (Pa)",
        Displacement: "Deslocamento (m)",
        WaterLevel: "Nível d'água"
    },
    "Barragem14julho-Results.vtk": {
        Displacement: "Deslocamento (m)",
        E_Young: "Módulo de elasticidade (MPa)",
        MatId: "MatId",
        PrincipalStress: "Tensão Principal (MPa)",
        StressX: "Tensão X (MPa)",
        StressY: "Tensão Y (MPa)",
        StressZ: "Tensão Z (MPa)"
    }
};
export default {
    name: "VtkSidebarItemVariables",
    components: {
        VtkSidebarItem,
        SwxDropdown
    },
    props: {
        itemClass: {
            type: [String, Object],
            required: true
        },
        vtkItem: {
            type: Object,
            required: true
        },
        vtkFile: {
            type: Object,
            required: true
        },
        busy: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        colorBy: {
            get() {
                const { readerId, colorBy } = this.vtkItem;
                const { location, name, vectorMode } = colorBy;
                return `${readerId}${SEP}${location}${SEP}${name}${SEP}${vectorMode}`;
            },
            set(value) {
                const params = value.split(SEP);
                const location = params[1];
                const name = params[2];
                const vectorMode = params[3];
                let component;
                let componentName;

                if (vectorMode === "Magnitude") {
                    component = -1;
                    componentName = vectorMode;
                } else {
                    const { components } = this.vtkItem.colorByList.find(
                        colorByListItem =>
                            location === colorByListItem.location &&
                            name === colorByListItem.name &&
                            vectorMode === colorByListItem.vectorMode
                    );
                    const currentComponent = components[components.length - 1];
                    component = currentComponent.component;
                    componentName = currentComponent.componentName;
                }

                this.$emit("changeColorBy", {
                    location,
                    name,
                    vectorMode,
                    component,
                    componentName
                });
            }
        },
        colorByOptions() {
            const { colorByList, readerId } = this.vtkItem;
            return colorByList.map(({ location, name, vectorMode }) => ({
                value: `${readerId}${SEP}${location}${SEP}${name}${SEP}${vectorMode}`,
                text: this.getText(name)
            }));
        },
        componentInfo: {
            get() {
                const { readerId, colorBy } = this.vtkItem;
                const {
                    location,
                    name,
                    vectorMode,
                    component,
                    componentName
                } = colorBy;
                return `${readerId}${SEP}${location}${SEP}${name}${SEP}${vectorMode}${SEP}${component}${SEP}${componentName}`;
            },
            set(value) {
                const params = value.split(SEP);
                const location = params[1];
                const name = params[2];
                const vectorMode = params[3];
                const component = parseInt(params[4], 10);
                const componentName = params[5];

                this.$emit("changeColorBy", {
                    location,
                    name,
                    vectorMode,
                    component,
                    componentName
                });
            }
        },
        componentInfoOptions() {
            const { readerId, colorBy, colorByList } = this.vtkItem;
            const { location, name, vectorMode } = colorBy;

            if (vectorMode === "Magnitude") {
                return [];
            }

            const { components } = colorByList.find(
                colorByListItem =>
                    location === colorByListItem.location &&
                    name === colorByListItem.name &&
                    vectorMode === colorByListItem.vectorMode
            );

            return components.map(({ component, componentName }) => ({
                value: `${readerId}${SEP}${location}${SEP}${name}${SEP}${vectorMode}${SEP}${component}${SEP}${componentName}`,
                text: componentName
            }));
        }
    },
    methods: {
        getText(name) {
            const { name: fileName } = this.vtkFile;
            const mapper = TranslationMap[fileName];
            if (mapper) {
                const newName = mapper[name];
                if (newName) {
                    return newName;
                }
            }

            return name;
        }
    }
};
</script>

<style lang="scss" scoped>
.chosen-component-select {
    /deep/ .dropdown-toggle {
        border-top: none;
    }
}
</style>
